import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';

import { PromotionEligibilityWarning } from 'core';
import { KorviuButtonComponent } from 'shared';

export interface IPromotionEligibilityModalData {
  variant: PromotionEligibilityWarning;
  eligibleLocation: string;
  accountLocation?: string | null;
}

@Component({
  selector: 'app-promotion-eligibility-modal',
  imports: [KorviuButtonComponent, TranslatePipe],
  templateUrl: './promotion-eligibility-modal.component.html',
  styleUrl: './promotion-eligibility-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PromotionEligibilityModalComponent {
  readonly #modal = inject(NzModalRef);
  readonly modalData = inject<IPromotionEligibilityModalData>(NZ_MODAL_DATA);

  readonly isConfirmed = signal<boolean>(false);
  readonly isConfirmLocationVariant = computed(() => this.modalData.variant === 'confirm_location');

  public close(): void {
    this.#modal.destroy();
  }

  public confirm(): void {
    if (this.isConfirmLocationVariant() && !this.isConfirmed()) {
      return;
    }

    this.#modal.close({ confirmed: true });
  }
}
